import "./Charts.css";
const Charts = () => {
 return (
  <div className="charts">
   <p className="title">Charts</p>
   <div className="charts-container">hey charts</div>
  </div>
 );
};

export default Charts;
